var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.628,
    height: 41.947,
    viewBox: "0 0 40.628 41.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563",
    transform: "translate(4593.298 1009.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(-4593.298 -1009.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_574",
    "data-name": "Path 574",
    d: "M-2928.375-1605.294a.375.375,0,0,1-.375-.375v-1.717l5.627-5.909v-12.586l0-.016a.7.7,0,0,0-.176-.493,1.65,1.65,0,0,0-1.212-.39h-.068a1.482,1.482,0,0,0-1.106.341.747.747,0,0,0-.186.542l0,.028v8.013a.375.375,0,0,1-.375.375.375.375,0,0,1-.375-.375v-7.973a1.49,1.49,0,0,1,.366-1.1,2.138,2.138,0,0,1,1.671-.6h.084a2.292,2.292,0,0,1,1.774.66,1.444,1.444,0,0,1,.347,1.038V-1613l-5.627,5.909v1.418A.374.374,0,0,1-2928.375-1605.294Z",
    transform: "translate(2962.998 1643.811)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_575",
    "data-name": "Path 575",
    d: "M-2943.13-1566.016h-.749v-3.4h-10.206v3.4h-.749v-4.151h11.7Z",
    transform: "translate(2979.313 1607.931)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_576",
    "data-name": "Path 576",
    d: "M-2950.675-1589.667a.375.375,0,0,1-.375-.375v-5.057l.113-.11,7.012-6.828a1.711,1.711,0,0,1,1.181-.5h0a1.979,1.979,0,0,1,1.447.734,2.245,2.245,0,0,1,.739,1.738,1.29,1.29,0,0,1-.318.732l-2.843,2.991a.375.375,0,0,1-.53.013.375.375,0,0,1-.013-.53l2.845-2.993a.573.573,0,0,0,.119-.337,1.649,1.649,0,0,0-.548-1.107,1.285,1.285,0,0,0-.89-.493h-.007a.987.987,0,0,0-.641.274l-.007.009,0,0-6.9,6.723v4.741A.374.374,0,0,1-2950.675-1589.667Z",
    transform: "translate(2976.946 1628.18)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M-2996.806-1565.828h-.749v-3.34h-10.362v3.34h-.749v-4.088h11.86Z",
    transform: "translate(3012.983 1607.774)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M-2998.981-1589.769h0a.374.374,0,0,1-.372-.377l.027-4.806-7.359-7.144c-.087-.038-.447-.008-1.091.587-.791.731-.621,1.19-.576,1.277l2.971,3.25a.374.374,0,0,1-.024.529.374.374,0,0,1-.529-.023l-3.01-3.292-.012-.017c-.03-.04-.705-1,.672-2.273a2.562,2.562,0,0,1,1.457-.793.847.847,0,0,1,.651.205l7.6,7.38-.03,5.125A.374.374,0,0,1-2998.981-1589.769Z",
    transform: "translate(3013.286 1628.376)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M-3014.16-1605.295a.374.374,0,0,1-.375-.375v-1.288l-5.66-6.089v-.147l.014-12.912a1.347,1.347,0,0,1,.383-.932,2.109,2.109,0,0,1,1.577-.538h.07a2.176,2.176,0,0,1,1.773.7,1.31,1.31,0,0,1,.285.764v8.159a.375.375,0,0,1-.375.375.374.374,0,0,1-.375-.375v-8.157a.582.582,0,0,0-.151-.335,1.57,1.57,0,0,0-1.171-.382,1.5,1.5,0,0,0-1.085.3.6.6,0,0,0-.182.4v.016l-.015,12.771,5.659,6.089v1.583A.374.374,0,0,1-3014.16-1605.295Z",
    transform: "translate(3020.194 1643.839)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_426",
    "data-name": "Rectangle 426",
    width: 1.124,
    height: 1.124,
    transform: "translate(6.065 39.325)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_429",
    "data-name": "Rectangle 429",
    width: 1.124,
    height: 1.124,
    transform: "translate(31.532 39.325)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_427",
    "data-name": "Rectangle 427",
    width: 1.124,
    height: 1.124,
    transform: "translate(7.938 39.325)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_428",
    "data-name": "Rectangle 428",
    width: 1.124,
    height: 1.124,
    transform: "translate(33.405 39.325)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(23.293)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-dollar2",
    "data-name": "Icon metro-dollar2",
    d: "M14.183,7.57a1.723,1.723,0,0,1-.451,1.193,1.945,1.945,0,0,1-1.171.618v.792a.14.14,0,0,1-.145.145h-.611a.147.147,0,0,1-.145-.145V9.381a2.854,2.854,0,0,1-.577-.14,2.781,2.781,0,0,1-.795-.419,2.581,2.581,0,0,1-.211-.17Q10.021,8.6,10,8.57a.138.138,0,0,1-.009-.186l.466-.611a.141.141,0,0,1,.1-.054.112.112,0,0,1,.109.041l.009.009a2.365,2.365,0,0,0,1.1.566,1.582,1.582,0,0,0,.335.036,1.1,1.1,0,0,0,.645-.195.634.634,0,0,0,.278-.552.459.459,0,0,0-.068-.24.849.849,0,0,0-.152-.19,1.243,1.243,0,0,0-.265-.17q-.181-.093-.3-.145t-.362-.147l-.278-.113q-.1-.041-.278-.12t-.283-.14Q10.945,6.3,10.8,6.2a1.6,1.6,0,0,1-.242-.192,2.822,2.822,0,0,1-.2-.222A1.108,1.108,0,0,1,10.2,5.52a1.816,1.816,0,0,1-.1-.3,1.572,1.572,0,0,1-.038-.353,1.548,1.548,0,0,1,.444-1.1,2.072,2.072,0,0,1,1.155-.607V2.348a.147.147,0,0,1,.145-.145h.611a.14.14,0,0,1,.145.145v.8a2.519,2.519,0,0,1,.5.1,2.9,2.9,0,0,1,.394.152,2.182,2.182,0,0,1,.288.17q.136.1.177.131t.068.063a.131.131,0,0,1,.023.172l-.367.661a.123.123,0,0,1-.1.072.144.144,0,0,1-.122-.032q-.014-.014-.066-.054t-.177-.12a2.337,2.337,0,0,0-.265-.145,2.023,2.023,0,0,0-.337-.118,1.511,1.511,0,0,0-.387-.052,1.177,1.177,0,0,0-.7.195.609.609,0,0,0-.233.72.51.51,0,0,0,.134.188,2,2,0,0,0,.179.149,1.6,1.6,0,0,0,.254.14q.17.079.274.122t.317.125q.24.091.367.143t.344.158a2.736,2.736,0,0,1,.342.192,2.891,2.891,0,0,1,.281.226,1.172,1.172,0,0,1,.24.288,1.641,1.641,0,0,1,.143.346,1.494,1.494,0,0,1,.059.426Z",
    transform: "translate(-6.025 -0.302)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    d: "M5.992,1.124A4.869,4.869,0,0,0,2.55,9.435,4.869,4.869,0,0,0,9.435,2.55,4.837,4.837,0,0,0,5.992,1.124M5.992,0A5.992,5.992,0,1,1,0,5.992,5.992,5.992,0,0,1,5.992,0Z",
    fill: "#f8a007"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    transform: "translate(6.814 6.741)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-dollar2-2",
    "data-name": "Icon metro-dollar2",
    d: "M16.125,10.037a2.515,2.515,0,0,1-.658,1.742,2.839,2.839,0,0,1-1.709.9v1.157a.2.2,0,0,1-.212.212h-.892a.214.214,0,0,1-.212-.212V12.681a4.167,4.167,0,0,1-.843-.2,4.059,4.059,0,0,1-1.16-.611,3.768,3.768,0,0,1-.307-.248q-.083-.079-.116-.119A.2.2,0,0,1,10,11.227l.681-.892a.206.206,0,0,1,.152-.079.164.164,0,0,1,.159.059l.013.013a3.452,3.452,0,0,0,1.606.826,2.309,2.309,0,0,0,.489.053,1.6,1.6,0,0,0,.942-.284.926.926,0,0,0,.407-.806.67.67,0,0,0-.1-.35,1.239,1.239,0,0,0-.221-.278,1.814,1.814,0,0,0-.387-.248q-.264-.136-.436-.212t-.529-.215l-.407-.165q-.149-.059-.407-.175t-.413-.2q-.155-.089-.373-.235a2.328,2.328,0,0,1-.354-.281,4.12,4.12,0,0,1-.288-.324,1.617,1.617,0,0,1-.235-.383,2.651,2.651,0,0,1-.139-.44,2.294,2.294,0,0,1-.056-.516,2.26,2.26,0,0,1,.648-1.6A3.025,3.025,0,0,1,12.443,3.6V2.415a.215.215,0,0,1,.212-.212h.892a.2.2,0,0,1,.212.212V3.578a3.677,3.677,0,0,1,.73.152,4.236,4.236,0,0,1,.575.221,3.185,3.185,0,0,1,.42.248q.2.139.258.192t.1.093a.191.191,0,0,1,.033.251l-.535.965a.18.18,0,0,1-.152.106.211.211,0,0,1-.178-.046q-.02-.02-.1-.079t-.258-.175a3.411,3.411,0,0,0-.387-.212,2.953,2.953,0,0,0-.492-.172,2.205,2.205,0,0,0-.565-.076,1.718,1.718,0,0,0-1.025.284.889.889,0,0,0-.34,1.051.744.744,0,0,0,.2.274,2.914,2.914,0,0,0,.261.218,2.328,2.328,0,0,0,.37.2q.248.116.4.178t.463.182q.35.132.535.208t.5.231a3.993,3.993,0,0,1,.5.281,4.22,4.22,0,0,1,.41.331,1.711,1.711,0,0,1,.35.42,2.4,2.4,0,0,1,.208.506,2.181,2.181,0,0,1,.086.621Z",
    transform: "translate(-4.216 0.572)",
    fill: "#f8a007"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_6-2",
    "data-name": "Ellipse 6",
    d: "M8.8,1.124A7.68,7.68,0,0,0,5.813,15.876a7.68,7.68,0,0,0,5.976-14.15,7.629,7.629,0,0,0-2.988-.6M8.8,0A8.8,8.8,0,1,1,0,8.8,8.8,8.8,0,0,1,8.8,0Z",
    fill: "#f8a007"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYield);
export default __webpack_public_path__ + "static/media/yield.291732b4.svg";
export { ForwardRef as ReactComponent };